import React from "react";
import { Avatar, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import GButtonContained from "./elements/GButtonContained";
import GButtonOutlined from "./elements/GButtonOutlined";
import iconProduct from "../assets/icons/iconProduct.svg";
import halfCircle from "../assets/icons/halfCircle.svg";
import points from "../assets/icons/points.svg";
import { Product } from "../interfaces/products";
import strings from "../helper/strings";
import Cookies from "universal-cookie";
import payKeys from "../config/pay-keys";

interface HeaderProps {
  setOpenPayPage: React.Dispatch<React.SetStateAction<boolean>>;
  setUrlIframe: React.Dispatch<React.SetStateAction<string>>;
  product: Product | undefined;
  executeScroll: () => any;
}

function Header(props: HeaderProps) {
  const cookies = new Cookies();

  function sendToPay() {
    props.setUrlIframe(
      `${payKeys}/?product-id=${
        props.product?.productId
      }&catalog-id=${props.product?.catalogId}&manager-id=${cookies.get(
        "refferer"
      )}&gooly=${cookies.get("gooly")}`
    );
    props.setOpenPayPage(true);
  }
  return (
    <Stack
      direction="row"
      sx={{ display: { md: "none", lg: "flex", sm: "none", xs: "none" } }}
    >
      <Box sx={{ direction: "rtl" }} flex={1}>
        <Avatar
          src={halfCircle}
          alt="Remy Sharp"
          sx={{
            position: "absolute",
            left: { md: -50, xl: 230 },
            top: { md: 225, xl: 225 },
            zIndex: 1,
            height: 300,
            width: 300,
          }}
        />
      </Box>

      <Box sx={{ direction: "rtl" }} flex={11}>
        <Stack
          direction="row"
          bgcolor="#421763"
          justifyContent="center"
          sx={{ borderTopLeftRadius: 400, borderBottomLeftRadius: 400 }}
        >
          <Stack
            flex={8}
            sx={{
              pr: 10,
              pt: 10,
            }}
          >
            <Box display="flex">
              <Box>
                <Typography
                  sx={{
                    pb: { sx: 0, xl: 2 },
                    fontSize: 46,
                    fontWeight: 600,
                    color: "white",
                  }}
                >
                  {props.product?.template.header}
                </Typography>
                <Typography sx={{ fontSize: 21, color: "white" }} pb={5.75}>
                  {props.product?.template.subHeader}
                </Typography>
                <Stack direction="row" pb={"8%"}>
                  <Typography
                    sx={{
                      fontFamily: "Poppins,Arial",
                      color: "white",
                      fontWeight: 700,
                      fontSize: 30,
                      pl: 2,
                    }}
                  >
                    ₪{Number(props.product?.["product.price"]).toLocaleString()}
                  </Typography>
                  <Box pl={2}>
                    <GButtonContained
                      handleAction={sendToPay}
                      text={strings.main.payOnline}
                    />
                  </Box>
                  <GButtonOutlined
                    handleAction={() => props.executeScroll()}
                    color="white"
                    text={strings.main.leftMessage}
                  />
                </Stack>
              </Box>
              <Box
                sx={{
                  height: 70,
                  width: 70,
                  left: "20%",
                  mt: "46%",
                  mx: "20%",
                  zIndex: 3,
                }}
                component="img"
                src={points}
              />
            </Box>
          </Stack>

          <Box>
            <Avatar
              src={
                props.product?.template.productIcon
                  ? props.product?.template.productIcon
                  : iconProduct
              }
              alt="Remy Sharp"
              sx={{
                "& .MuiAvatar-img": {
                  width: "auto",
                  height: "45%",
                },
                backgroundColor: "#550EC3",
                pl: 15,
                height: 526,
                width: 526,
              }}
            />
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
}

export default Header;
